<p>closing-pack-modal works!</p>
